import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  fdeStatusObject
} from "../../../common/it-interface";
import {SIDE_NAV_TITLES} from "../../../common/it-constants";
import {convertToSnakeCase} from "../../../../ccass/utils/util-functions";
import { FdeDeoDistributorService } from "../../eod-distributor.service";

@Component({
  selector: 'app-fund-day-end-report',
  templateUrl: './fund-day-end-report.component.html',
  styleUrls: ['./fund-day-end-report.component.scss']
})
export class FundDayEndReportComponent implements OnInit {

  @Output() titleHeading = new EventEmitter<string>();
  @Output() shouldDisplayTitle = new EventEmitter<boolean>();

  pageTitle: string = SIDE_NAV_TITLES.fundDayEndReport;
  listOfFdeStatusReport: fdeStatusObject;
  showAlertPopup = false;
  message: string;
  fundDayEndReportKey = convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);

  constructor(
    private fdeDeoDistributorService: FdeDeoDistributorService
  ) { }

  ngOnInit() {
    this.getLists();
  }

  getLists() {
  }

  showWarningPopup(message) {
    this.showAlertPopup = true;
    this.message = message;
  }

}
